var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "487.74 148.07 105.65 104.34",
    width: 106.3,
    height: 95.65,
    id: "uuid-2b67eb53-902b-4207-af2f-4310fe0b207a",
    "data-name": "Layer 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".circle{fill:#fff;stroke:none}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 540.04,
    cy: 201.29,
    r: 8.35
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 540.04,
    cy: 222.42,
    r: 8.35
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 540.04,
    cy: 244.07,
    r: 8.35
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 520.74,
    cy: 211.98,
    r: 8.35
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 502.22,
    cy: 221.21,
    r: 8.35
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 578.39,
    cy: 221.21,
    r: 8.35
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 559.87,
    cy: 211.98,
    r: 8.35
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 558.57,
    cy: 187.72,
    r: 8.35
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 582.04,
    cy: 198.94,
    r: 8.35
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 577.09,
    cy: 178.59,
    r: 8.35
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 561.96,
    cy: 161.63,
    r: 8.35
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 496.09,
    cy: 200.76,
    r: 6.65
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 521.13,
    cy: 187.59,
    r: 6.65
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 539.52,
    cy: 177.15,
    r: 5.35
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 501.3,
    cy: 176.76,
    r: 5.35
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 519.3,
    cy: 162.94,
    r: 4.63
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 539.26,
    cy: 156.42,
    r: 4.63
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 562.22,
    cy: 239.11,
    r: 8.35
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 518.65,
    cy: 239.11,
    r: 8.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e784c4747dd857355aa75c27cb47216c.svg";
export { ForwardRef as ReactComponent };